import { GooglePayOneClick } from 'shared/components/purchase-methods/GooglePayOneClick'
import { ApplePayOneClick } from 'shared/components/purchase-methods/ApplePayOneClick'
import { PaymentSessionResponse } from 'shop/api/orders-v2.api'
import { useShopStores } from 'shop/hooks/use-store'
import { convertPriceForStripe } from '@elo-kit/utils/stripe.utils'
import { PayPalExpressButton } from '../components/payment/new/paypal-controls/PayPalExpressButton'

export const expressCheckoutComponentMaps = () => {
  const { paymentStore, sellerStore } = useShopStores()

  return {
    paypal: () => {
      if (!paymentStore.isPaypalExpressAvailable) return null

      return (
        <PayPalExpressButton
          paymentStore={paymentStore}
          createPaymentSession={() => paymentStore.createPaymentSession() as unknown as Promise<PaymentSessionResponse>}
        />
      )
    },
    apple_pay: () => {
      if (
        !paymentStore.isStripeExpressAvailable ||
        !paymentStore.appleAvailability.applePay ||
        !paymentStore.isApplePayInPlan()
      ) {
        return null
      }

      return (
        <ApplePayOneClick
          appleProvider={sellerStore.item.applePayProvider}
          applePubKey={sellerStore.applePublicKey}
          payOptions={{
            amount: convertPriceForStripe(paymentStore.totalPrice()),
            currency: paymentStore.currency,
          }}
        />
      )
    },
    google_pay: () => {
      if (
        !paymentStore.isStripeExpressAvailable ||
        !paymentStore.googleAvailability.googlePay ||
        !paymentStore.isGooglePayInPlan()
      ) {
        return null
      }

      return (
        <GooglePayOneClick
          googleProvider={sellerStore.item.googlePayProvider}
          googlePubKey={sellerStore.googlePublicKey}
          payOptions={{
            amount: convertPriceForStripe(paymentStore.totalPrice()),
            currency: paymentStore.currency,
          }}
        />
      )
    },
  }
}
